// Single source of truth for external Discord destinations.
// Install URL adds the deck-check bot to a server; invite URL joins
// the Commandersalt community server (where Manuel lives).
export const DISCORD_BOT_INSTALL_URL =
    'https://discord.com/oauth2/authorize?client_id=1130881153998540800&permissions=2147483648&scope=bot';

export const DISCORD_INVITE_URL = 'https://discord.gg/Yb2CAxcJcf';
